import { Rectangle } from "pixi.js";
import { Signal } from "typed-signals";
import { Scene, FullScreenBackgroundFill } from "onearm";
import { TotalBetControl } from "../controllers/TotalBetControl.js";
import { formatCurrency } from "../../utils/formatCurrency.js";

export class SystemSettingsPopupScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", name: "SystemSettingsPopupScene", ...parameters });
    }

    create(options) {
        super.create(options);

        const { screen, totalBets, bet, isMusicMuted, isSfxMuted } = options;

        this.onPressClose = new Signal();
        this.onChangeAmbientMusic = new Signal();
        this.onChangeSoundFX = new Signal();
        this.onChangeIntroScreen = new Signal();
        this.onPressGameHistory = new Signal();
        this.onPressHome = new Signal();

        this.fill = this.addChildAt(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        0);

        this.betControl = new TotalBetControl(totalBets);
        this.betControl.setTotalBet(bet);
        this.onTotalBetChanged = this.betControl.onTotalBetChanged;

        this.betControl.onTotalBetChanged.connect((value) => {
            this.setBet(value);
        });

        this.layout.forAll("CloseButton", (closeButton) => {
            closeButton.onPress.connect(() => this.onPressClose.emit());
        });
        this.layout.forAll("AmbientMusicToggle", (toggle) => {
            toggle.setState(!isMusicMuted);
            toggle.onChange.connect((value) => this.onChangeAmbientMusic.emit(value));
        });
        this.layout.forAll("SoundFXToggle", (toggle) => {
            toggle.setState(!isSfxMuted);
            toggle.onChange.connect((value) => this.onChangeSoundFX.emit(value));
        });
        this.layout.forAll("IntroScreenToggle", (toggle) => {
            toggle.onChange.connect((value) => this.onChangeIntroScreen.emit(value));
        });
        this.layout.forAll("TotalBetPanel.MinusButton", (minusButton) => {
            minusButton.onPress.connect(() => this.betControl.previousTotalBet());
        });
        this.layout.forAll("TotalBetPanel.PlusButton", (plusButton) => {
            plusButton.onPress.connect(() => this.betControl.nextTotalBet());
        });
        this.layout.forAll("GameHistoryLink", (gameHistoryLink) => {
            const button = this.makeButton(gameHistoryLink);
            button.onPress.connect(() => this.onPressGameHistory.emit());
        });
        this.layout.forAll("HomeLink", (homeLink) => {
            const button = this.makeButton(homeLink);
            button.onPress.connect(() => this.onPressHome.emit());
        });

        this.setBet(bet);

        this.onChangeAmbientMusic.connect(this.handleChangeAmbientMusic.bind(this));
        this.onChangeSoundFX.connect(this.handleChangeSoundFX.bind(this));
        this.onChangeIntroScreen.connect(this.handleChangeIntroScreen.bind(this));
    }

    handleChangeAmbientMusic(value) {
        this.layout.forAll("AmbientMusicToggle", (toggle) => {
            toggle.setState(value);
        });
    }

    handleChangeSoundFX(value) {
        this.layout.forAll("SoundFXToggle", (toggle) => {
            toggle.setState(value);
        });
    }

    handleChangeIntroScreen(value) {
        this.layout.forAll("IntroScreenToggle", (toggle) => {
            toggle.setState(value);
        });
    }

    setBet(bet) {
        this.layout.forAll("TotalBetPanel.ValueContainer.value", (betText) => {
            betText.text = formatCurrency(bet);
        });
    }

    makeButton(displayObject) {
        displayObject.eventMode = "static";
        displayObject.cursor = "pointer";
        displayObject.onPress = new Signal();
        displayObject.on("pointerdown", () => {
            displayObject.onPress.emit();
        });

        displayObject.hitArea = new Rectangle(0, 0, displayObject.width, displayObject.height);

        return displayObject;
    }
}
